import React from 'react';
import { useStorageObjectUrl } from '../../services/file.service';
import Loader from './Loader';

type SecureImgProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  storageSrc: string | null | undefined;
  placeholderClassName?: string;
  fallbackSrc?: string;
  showLoader?: boolean;
};

export const SecureImg: React.FC<SecureImgProps> = ({
  storageSrc,
  placeholderClassName = 'bg-gray-200 animate-pulse',
  fallbackSrc,
  alt,
  showLoader = false,
  ...imgProps
}) => {
  const { url, loading, error } = useStorageObjectUrl(storageSrc);

  if (loading) {
    return (
      <div
        className={placeholderClassName}
        style={{
          width: typeof imgProps.width === 'number' ? `${imgProps.width}px` : imgProps.width,
          height: typeof imgProps.height === 'number' ? `${imgProps.height}px` : imgProps.height,
          borderRadius: '0.5rem',
        }}
        aria-label="Loading image..."
      >
        {showLoader && <Loader loader={showLoader} dimentions={`w-10 h-10`} />}
      </div>
    );
  }

  const src = url ?? fallbackSrc ?? '';

  return (
    <img
      {...imgProps}
      alt={alt}
      src={src}
      onError={(e) => {
        if (!fallbackSrc) return;
        (e.currentTarget as HTMLImageElement).src = fallbackSrc;
      }}
    />
  );
};
